<template>
  <div>
    <!-- :headers="{ 'X-Access-Token': token }  :data="{ biz: bizPath }"" -->
    <a-upload
      name="uploadFile"
      list-type="picture-card"
      :show-upload-list="false"
      :action="uploadAction"
      :before-upload="beforeUpload"
      @change="handleChange"
      @preview="handlePreview"
      :disabled="justLook"
      :headers="{ Authorization: token }"
      style="position: relative"
    >
      <div
        v-if="imageUrl"
        class="image-yic"
        style="width: 100%; max-height: 110px"
        @mouseover="() => (showZezhao = true)"
        @mouseleave="() => (showZezhao = false)"
      >
        <div style="width: 100%">
          <img
            :src="imageUrl"
            alt="file"
            style="width: 100%; max-height: 90px"
          />
          <div class="but-group" v-if="showZezhao">
            <div>
              <span
                class="orgin-images"
                @click.stop="() => $refs.showImage.openModal()"
                >原图</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="image-yic"
        @mouseover="() => (showZezhaoNone = true)"
        @mouseleave="() => (showZezhaoNone = false)"
      >
        <a-icon :type="loading ? 'loading' : 'plus'" v-if="!isTou" />

        <img
          :src="require('@/assets/images/personal/' + touImageUrl)"
          alt=""
          v-else
        />

        <div class="but-group" v-if="showZezhaoNone">
          <div>
            <span class="orgin-images">上传照片</span>
          </div>
        </div>
      </div>
    </a-upload>
    <!-- 图片展示弹窗 -->
    <ImageDialog ref="showImage" :imageUrl="[imageUrl]"> </ImageDialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// 导入弹窗
import { Dialog, ImageDialog } from "@/components/public/dialog/ant";
import config from "@/config";

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  components: {
    Dialog,
    ImageDialog,
  },
  props: {
    isTou: {
      type: Boolean,
      default: () => false,
    },
    touImageUrl: {
      type: String,
      default: () => "actor_icon.png",
    },
    bizPath: {
      type: String,
      required: false,
      default: "temp",
    },
    imageUrl: {
      type: String,
      default: () => "",
    },

    // 限制上传的大小（KB）
    imageMaxSize: {
      type: Number,
      default: () => 200,
    },

    // 是否只查看
    justLook: { type: Boolean, default: false },
  },
  data() {
    return {
      uploadAction: config.SERVICES.BASE_URL + "/file/upload/",
      loading: false,
      previewVisible: false,
      showZezhao: false,
      showZezhaoNone: false,
    };
  },
  methods: {
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        console.log("####返回的数据####", info.file);

        if (info.file.response.code === 0) {
          // ############################根据原始文件获得base64回显#####################
          getBase64(info.file.originFileObj, (imageUrl) => {
            this.$emit("tranBase64", imageUrl);
          });
          // ###########################根据原始文件获得base64回显#####################
          //  传出图片url
          this.$emit("changeImageUrl", info.file.response.data);
          //   传出图片大小size
          this.$emit("changeImageSize", info.file.size);
        }
      }

      this.loading = false;
    },
    beforeUpload(file) {
      console.log("##########即将上传的图片对象########", file);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片必须小于 2M!");
      }
      return isLt2M;
    },
    handlePreview() {
      this.previewVisible = true;
    },
  },

  computed: {
    ...mapGetters("auth", ["token"]),
  },
};
</script>
<style lang="less">
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.orgin-images {
  font-size: 12px;
  cursor: pointer;
  padding: 5px;
}

.image-yic {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .but-group {
    position: absolute;
    z-index: 2;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #000;
    opacity: 0.3;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 添加遮罩层 */
}
.buts-group-del {
  position: absolute;
  z-index: 3;
  top: 0;
  right: 5px;
  cursor: pointer;
  color: #ab0001;
}
.ant-upload-picture-card-wrapper {
  display: block;
}
</style>